import { env } from '$env/dynamic/public';
import type { EnvType } from '$lib/interfaces/local.type';

const PROJECT_NAME = 'Documents';
const ENV = env.PUBLIC_ENV as EnvType;
const IS_DEV = env.PUBLIC_IS_DEV !== 'false';
const SENTRY_DSN = 'https://1a32babb4f6813de8ed71c87b7d7d252@o4505827250929664.ingest.us.sentry.io/4509320298823680';

export const CONSTANTS = {
	PROJECT_NAME: PROJECT_NAME,
	ENV: ENV,
	IS_DEV: IS_DEV,
	SENTRY_DSN: SENTRY_DSN,
	IS_PROD: ENV === 'production',
	IS_HIGHER_ENV: ENV === 'production' || ENV === 'sandbox'
} as const;
